import { firestore } from '../../firebase/firebase';
import { FirestoreCollection } from '../../firebase/firebase.models';
import { useSequentialId } from '../useSequentialId.hook';

export const onLogDeleteAccount = (userId: string): void => {
  const { generateSequentialId } = useSequentialId();

  generateSequentialId().then((newCounter) => {
    firestore
      .collection(FirestoreCollection.EVENTS)
      .doc(newCounter.toString())
      .set({
        method: 'onLogDeleteAccount',
        details: 'User deleted account',
        userId: userId,
        date: new Date(),
      })
      .catch((error) => {
        console.log(error);
      });
  });
};
